import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Comment = Loadable({
    loader: () => import(/* webpackChunkName: "Comment" */ './comment'),
    loading: () => <div />,
});
